import type React from 'react'
import {CardV2} from 'pepsico-ds'
import styles from './CardWrapper.module.css'
import type {ICardV2Props} from 'pepsico-ds'

const Card: React.FC<ICardV2Props> = props => {
  const {className, cardBody, children, ...rest} = props
  return (
    <CardV2
      cardBody={{
        ...(cardBody || {}),
        type: 'slot',
        slot: children,
      }}
      className={`${className || ''} ${styles.cardWrapper}`.trim()}
      {...rest}
    />
  )
}

export default Card
